const Errors = require('@genx/error');

module.exports = Errors;
